import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTipoContrato = '/service/materiais/tipocontrato/'

class TipoContratoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getTipoContrato() {
        return this.conex.get(urlTipoContrato + 'todos/')
    }
}

export default TipoContratoService
